import { addZ } from "@jugl-web/utils/date-time/addZ";
import { TicketDetailsDto } from "./TicketDetailsDto";
import { TicketDetailsModel } from "./TicketDetailsModel";

export const transformTicketDetailsDtoToModel = (
  dto: TicketDetailsDto
): TicketDetailsModel => ({
  ...dto,
  due_at: dto.due_at ? addZ(dto.due_at) : null,
  inserted_at: addZ(dto.inserted_at),
  updated_at: addZ(dto.updated_at),
});
